import { Box, Tab } from '@mui/material';
import { useState } from 'react';

import { EstadosSolicitudEnumChoice, a11yProps, sizeTab } from '@/shared';
import {
  CustomTabPanel,
  FormTabsOnly,
  SingleTableBoxScene,
} from '@/shared/components/ui';
import CodigosOTPPendientes from './CodigosOTPPendientes';


export type CodigosOTPPageProps = {};

const CodigosOTPPage: React.FC<CodigosOTPPageProps> = () => {


  const [valueTab, setValueTab] = useState(1);
  const handleMethodChange = (_event: any, newValue: number) => {
    setValueTab(newValue);
  };

  return (
    <SingleTableBoxScene title="Códigos OTP">
      <Box
        sx={{
          bgcolor: 'background.paper',
          maxWidth: sizeTab,
          paddingBottom: 2,
        }}
      >
        <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
          <Tab label="Pendientes" value={1} {...a11yProps(1)} />
          <Tab label="Verificados" value={2} {...a11yProps(2)} />
          <Tab label="Expirados" value={3} {...a11yProps(3)} />
        </FormTabsOnly>
      </Box>

      <CustomTabPanel value={valueTab} index={1}>
        <CodigosOTPPendientes estado={EstadosSolicitudEnumChoice.EN_ESPERA} />
      </CustomTabPanel>

      <CustomTabPanel value={valueTab} index={2}>
        <CodigosOTPPendientes estado={EstadosSolicitudEnumChoice.APROBADO} />
      </CustomTabPanel>

      <CustomTabPanel value={valueTab} index={3}>
        <CodigosOTPPendientes estado={EstadosSolicitudEnumChoice.FINALIZADO} />
      </CustomTabPanel>
    </SingleTableBoxScene>
  );
};

export default CodigosOTPPage;
